'use client';

import { useGlobalErrorLogger } from '@/app/hooks/useGlobalErrorLogger';
import { useLandingPageTracking } from '@/app/hooks/useLandingPageTracking';
import { useGlobalScreenHeight } from '@/app/hooks/useScreenHeight';
import { useSupportTailwindV4 } from '@/app/hooks/useSupportTailwindV4';
import { useRUMRecording } from '@/components/hooks/rum';
export const ClientConfigs = () => {
  useRUMRecording();
  useGlobalErrorLogger();
  useGlobalScreenHeight();
  useSupportTailwindV4();
  useLandingPageTracking();
  return null;
};